import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Информация об операции", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 mb-1" }, "Дата проведения операции", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_4 = { class: "text-xs text-gray-400 mb-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 mb-1" }, "Сумма операции", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 mb-1" }, "Детализация по счетам", -1)
const _hoisted_10 = { class: "w-4 text-xs text-gray-400" }
const _hoisted_11 = { class: "mt-1 font-medium" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 mb-1" }, "Детализация операции", -1)
const _hoisted_15 = { class: "-mx-2" }
const _hoisted_16 = { class: "w-4 text-xs text-gray-400" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-xs text-gray-400" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "text-xs text-gray-400" }
const _hoisted_21 = {
  key: 0,
  class: "font-medium"
}
const _hoisted_22 = {
  key: 1,
  class: "font-medium"
}

import { computed, PropType } from "vue";
import { useVModel } from "@vueuse/core";

import { getCodeName, getTypeName } from "@/constants";
import { IOperation } from "@/types/operation";
import { formatCurrency, formatDate } from "@/utils";

import UiModalPage from "@/components/ui/UiModalPage.vue";
import UiModalPageHeader from "@/components/ui/UiModalPageHeader.vue";
import UiModalPageHeaderClose from "@/components/ui/UiModalPageHeaderClose.vue";
import UiSimpleCell from "../ui/UiSimpleCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationPreviewModal',
  props: {
  modelValue: Boolean,
  operation: { type: Object as PropType<IOperation>, required: true },
},
  setup(__props) {

const props = __props



const show = useVModel(props, "modelValue");

const sum = computed(() => formatCurrency(props.operation.sum / 100));
const date = computed(() =>
  formatDate(props.operation.date, { dateStyle: "short", timeStyle: "short" })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiModalPage, {
    modelValue: _unref(show),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null))
  }, {
    header: _withCtx(() => [
      _createVNode(UiModalPageHeader, null, {
        before: _withCtx(() => [
          _createVNode(UiModalPageHeaderClose, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = false))
          })
        ]),
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_unref(date)), 1)
      ]),
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(getTypeName)(__props.operation.type)), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(getCodeName)(__props.operation.code)), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_unref(sum)), 1)
      ]),
      (__props.operation.sumDetails.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.operation.sumDetails, (detail, index) => {
              return (_openBlock(), _createBlock(UiSimpleCell, {
                key: detail.description
              }, {
                before: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(index + 1), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(detail.description), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(formatCurrency)(detail.sum / 100)), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.operation.info.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.operation.info, (info, index) => {
                return (_openBlock(), _createBlock(UiSimpleCell, {
                  key: index,
                  multiline: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(index + 1) + ".", 1)
                  ]),
                  default: _withCtx(() => [
                    (__props.operation.type === 10 && __props.operation.code !== 20)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("p", null, "Купюра в " + _toDisplayString(_unref(formatCurrency)(info.nomination / 100)), 1),
                          _createElementVNode("p", _hoisted_18, " x" + _toDisplayString(info.count) + " " + _toDisplayString(_unref(formatCurrency)(info.nomination / 100)), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("p", null, _toDisplayString(info.name) + " " + _toDisplayString(info.weight && `(${info.weight})`), 1),
                          _createElementVNode("p", _hoisted_20, " x" + _toDisplayString(info.count) + " " + _toDisplayString(_unref(formatCurrency)(info.price / 100)), 1)
                        ]))
                  ]),
                  after: _withCtx(() => [
                    (__props.operation.type === 10 && __props.operation.code !== 20)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(formatCurrency)((info.count * info.nomination) / 100)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(formatCurrency)((info.price * info.count) / 100)), 1))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})